var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransferFrom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_691_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8948 34C27.2836 34 34.8948 26.3888 34.8948 17C34.8948 7.61116 27.2836 0 17.8948 0C8.50593 0 0.894775 7.61116 0.894775 17C0.894775 26.3888 8.50593 34 17.8948 34Z",
    fill: "#E8A941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11.75L17.2929 11.0429L18 10.3358L18.7071 11.0429L18 11.75ZM19 18.5C19 19.0523 18.5523 19.5 18 19.5C17.4477 19.5 17 19.0523 17 18.5L19 18.5ZM13.5429 14.7929L17.2929 11.0429L18.7071 12.4571L14.9571 16.2071L13.5429 14.7929ZM18.7071 11.0429L22.4571 14.7929L21.0429 16.2071L17.2929 12.4571L18.7071 11.0429ZM19 11.75L19 18.5L17 18.5L17 11.75L19 11.75Z",
    fill: "#2B2C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 20L12.75 20.75C12.75 21.5784 13.4216 22.25 14.25 22.25L21.75 22.25C22.5784 22.25 23.25 21.5784 23.25 20.75V20",
    stroke: "#2B2C37",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_691_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransferFrom);
export default __webpack_public_path__ + "static/media/icon-transfer-from.172c8295fbff0c19aa605a9b334c2252.svg";
export { ForwardRef as ReactComponent };